/** Voice note helpers — reuse attachment encryption (SEC-MED). */

import { prepareAttachmentPayload, type AttachmentManifest } from "@veto/protocol";

export async function prepareVoiceNote(
  blob: Blob,
  durationMs: number,
): Promise<{
  manifest: AttachmentManifest;
  sealedBody: string;
  label: string;
}> {
  const mediaType = blob.type || "audio/webm";
  const fileName = `voice-${Date.now()}.${voiceExtension(mediaType)}`;
  const { manifest, sealedBody, label } = await prepareAttachmentPayload({
    file: blob,
    fileName,
    mediaType,
    kind: "voice",
    durationMs,
  });
  return { manifest, sealedBody, label };
}

/** File extension matching the recorded container (receivers and "Share" use it). */
export function voiceExtension(mediaType: string): string {
  const base = mediaType.toLowerCase().split(";")[0]!.trim();
  if (base === "audio/mp4" || base === "audio/aac" || base === "audio/x-m4a") return "m4a";
  if (base === "audio/ogg") return "ogg";
  if (base === "audio/mpeg") return "mp3";
  return "webm";
}

export function formatDuration(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}
